import $ from 'jquery';
import Swiper from 'swiper';
import {Autoplay, Navigation} from 'swiper/modules';
// import Swiper styles
import 'swiper/css';
//import 'swiper/css/navigation';
//import 'swiper/css/pagination';
//import 'swiper/css/scrollbar';

$(document).ready(function () {

    $('.discoverCarousel').each(function (index, element) {
        const swiper = element.querySelector('.swiper');
        const nav = element.querySelector('.carousel__nav');
        const nextButton = element.querySelector('.carousel__next');
        const prevButton = element.querySelector('.carousel__prev');
        new Swiper(swiper, {
            modules: [Navigation, Autoplay],
            spaceBetween: 16,
            /*autoplay: {
                pauseOnMouseEnter: true
            },*/
            autoplay: false,
            loop: false,
            slidesOffsetAfter: 70,
            breakpoints: {
                720: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                    slidesOffsetAfter: 0,
                },
                1120: {
                    slidesPerView: 2,
                    slidesOffsetAfter: 0
                },
                1400: {
                    slidesPerView: 3,
                    slidesOffsetAfter: 0
                }
            },
            navigation: {
                enabled: !!nav,
                addIcons: false,
                nextEl: nextButton,
                prevEl: prevButton,
            }
        });
    });
});